// extracted by mini-css-extract-plugin
export var title = "SecurityAndPrivacyMain-module--title--sMAGI";
export var section = "SecurityAndPrivacyMain-module--section--l58AU";
export var section_withImage = "SecurityAndPrivacyMain-module--section_withImage--MxgbG";
export var section__title = "SecurityAndPrivacyMain-module--section__title--Px+9v";
export var section__text = "SecurityAndPrivacyMain-module--section__text--YT+cI";
export var section__img = "SecurityAndPrivacyMain-module--section__img--3nDVL";
export var link = "SecurityAndPrivacyMain-module--link--L6sa9";